import styled from "styled-components"
import { useAppState } from "../state/app/useAppState"

const StyledMobileTray = styled.div<{ expanded: boolean }>`
position: fixed;
top: ${({ expanded }) => expanded ? '60px': 'calc(100% - 198px)'};
bottom: 98px;
left: 0;
right: 0;
padding-bottom: 10px;
padding-top: 10px;
min-height: 100px;
z-index: 100;

background: linear-gradient(to top, #fafafa 0%, #fafafa 20px, transparent 100px);
display: flex;
justify-content: space-between;
align-items: flex-end;

div.inner {
    display: contents;
}
`

const StyledDesktopTray = styled.div<{ expanded: boolean }>`
position: fixed;
bottom: 0;
width: 100%;
left: 0;
right: 0;
z-index: 100;
background: ${p => p.theme.secondaryColor};
display: flex;
justify-content: space-between;
align-items: flex-end;

div.inner {
    width: 1280px;
    margin: 0 auto;
    padding: 15px 0 15px 0;
}
`

const LeftTray = styled.div.attrs({
    className: "left-tray"
})`
padding: 0 0 0 15px;
float: left;

> .button {
    margin-right: 15px;
    margin-bottom: 5px;
}
`

const RightTray = styled.div.attrs({
    className: "right-tray"
})`
padding: 0 15px 0 0;
float: right;

> .button {
    margin-left: 15px;
    margin-bottom: 5px;
}
`

export function UiTrays(){

    const app = useAppState()
    const StyledTray = app.device.isMobile ? StyledMobileTray : StyledDesktopTray
    const leftTray = app.ui('leftTray').get()
    const rightTray = app.ui('rightTray').get()

    const showTray = leftTray || rightTray

    return <StyledTray expanded={app.menu.isOpen}>
        { showTray && <div className="inner">
            <LeftTray>{leftTray}</LeftTray>
            <RightTray>{rightTray}</RightTray>
        </div> }
    </StyledTray>

}